import { defineMessages } from 'react-intl';

import { EUnit } from '@model';

export const messages = defineMessages({
  pieceUnit: {
    id: 'checkout.cartPage.pieceUnit',
    defaultMessage: 'pc.',
    description: 'Abbreviation for piece or pieces',
  },
  [EUnit.PIECES]: {
    id: 'checkout.cartPage.pieceUnit',
    defaultMessage: 'pc.',
    description: 'Abbreviation for piece or pieces',
  },
  [EUnit.PACKAGE]: {
    id: 'checkout.cartPage.packageUnit',
    defaultMessage: 'pkg.',
    description: 'Abbreviation for unit of package',
  },
  [EUnit.GRAMS]: {
    id: 'checkout.cartPage.gramUnit',
    defaultMessage: 'g',
    description: 'Abbreviation for unit of grams',
  },
  [EUnit.MILLILITERS]: {
    id: 'checkout.cartPage.milliliterUnit',
    defaultMessage: 'ml',
    description: 'Abbreviation for unit of milliliters',
  },
  [EUnit.CENTIMETERS]: {
    id: 'checkout.cartPage.centimeterUnit',
    defaultMessage: 'cm',
    description: 'Abbreviation for unit of centimeters',
  },
  [EUnit.METERS]: {
    id: 'checkout.cartPage.meterUnit',
    defaultMessage: 'm',
    description: 'Abbreviation for unit of meters',
  },

  removeProductTitle: {
    id: 'checkout.cartPage.removeProductTitle',
    defaultMessage: 'Remove product from cart',
    description: 'Remove product button title',
  },
  removeProductButton: {
    id: 'checkout.cartPage.removeProductButton',
    defaultMessage: 'remove',
    description: 'Remove product button',
  },
  totalPrice: {
    id: 'checkout.cartPage.totalPrice',
    defaultMessage: 'Total price including VAT:',
    description: 'Text that is being displayed in cart in total price row',
  },
  cartTitle: {
    id: 'checkout.cartPage.cartTitle',
    defaultMessage: 'Shopping Basket',
    description: 'Title that is being displayed at the top of the cart page',
  },
  freeProduct: {
    id: 'checkout.cartPage.freeProduct',
    defaultMessage: 'free',
    description: 'Text that is being displayed if the price of the product is equal to zero',
  },
  achievedFreeShipping: {
    id: 'checkout.cartPage.freeDelivery.achievedFreeShipping',
    defaultMessage: 'Free delivery',
    description: 'Inform customer about free delivery is achieved',
  },
  amountUntilFreeDelivery: {
    id: 'checkout.cartPage.freeDelivery.amountUntilFreeDelivery',
    defaultMessage: '{price} to get free delivery',
    description: 'How much is needed for free delivery',
  },

  amountUntilFreeDeliveryWithReco: {
    id: 'checkout.cartPage.freeDelivery.amountUntilFreeDeliveryWithReco',
    defaultMessage: 'Nakupte ještě za {price} nebo nějaký z {link} a získáte dopravu zdarma.',
    description: 'How much is needed for free delivery with reco.',
  },

  linkForRecoModal: {
    id: 'checkout.cartPage.freeDelivery.linkForRecoModal',
    defaultMessage: 'vybraných produktů',
    description: 'Link for open modal with reco products in free delivery',
  },

  somethingWentWrong: {
    id: 'checkout.cartPage.somethingWentWrong',
    defaultMessage: 'Ooops something went wrong',
    description: 'Short General message used to display error',
  },
  discountLoyaltyMessage: {
    id: 'checkout.cartPage.discountLoyaltyMessage',
    defaultMessage: 'Your loyalty discount for regular customers. {percent}%',
    description: 'Message used to inform customer about discount loyalty amount',
  },
  discountLoyaltyDescription: {
    id: 'checkout.cartPage.discountLoyaltyDescription',
    defaultMessage: 'Unfortunately, you cannot redeem the loyalty discount for a special offer.',
    description: 'Message used to inform customer about limitations of usage of loyalty discount',
  },

  benefitFreeShippingPrelongBenefit: {
    id: 'checkout.cartPage.benefitFreeShippingPrelongBenefit',
    defaultMessage: 'Shipping over {price} is free <span>till {date}.</span>',
    description: 'Message for the customer in the benefits section.',
  },
  benefitFreeShippingPrelongBenefitDescription: {
    id: 'checkout.cartPage.benefitFreeShippingPrelongBenefit',
    defaultMessage: 'If you buy again over {price} extend your free shipping until {date}',
    description: 'Description for information message in the benefits section.',
  },
  benefitFreeShippingActiveBenefit: {
    id: 'checkout.cartPage.benefitFreeShippingActiveBenefit',
    defaultMessage: 'You have free shipping <span>till {date}.</span>',
    description: 'Message for the customer in the benefits section.',
  },
  benefitFreeShippingMoreInformation: {
    id: 'checkout.cartPage.benefitFreeShippingMoreInformation',
    defaultMessage: 'More information',
    description: 'Used in link.',
  },
  benefitFreeShippingNextTime: {
    id: 'checkout.cartPage.benefitFreeShippingNextTime',
    defaultMessage: 'Next time free shipping?',
    description: 'Message for the customer in the benefits section.',
  },
  benefitFreeShippingGetBenefitByForAmount: {
    id: 'checkout.cartPage.benefitFreeShippingGetBenefitByForAmount',
    defaultMessage: 'Buy for <b> {price} </b> and get free shipping for the next six months.',
    description: 'Message for the customer in the benefits section.',
  },
  benefitFreeShippingGetBenefitSubscribeToTheNewsletter: {
    id: 'checkout.cartPage.benefitFreeShippingGetBenefitByForAmount',
    defaultMessage:
      'Subscribe to our newsletter, complete your purchase and get free shipping for the next six months.',
    description:
      'If the customer is not already subscribed to the newsletter, it displays a message in the benefits section.',
  },

  orderLimitReachedMaxValueMessage: {
    id: 'checkout.cartPage.orderLimitReached.maximumValueMessage',
    defaultMessage:
      'The goods are being sent from Czech Republic and due to customs management the order can have maximum value <b> {value} {currency} </b>.',
    description:
      'For some countries there is a order limit which cant be exceeded. This message is part of the modal displayed to the customer',
  },
  orderLimitReachedNextPurchaseAdviceMessage: {
    id: 'checkout.cartPage.orderLimitReached.nextPurchaseAdviceMessage',
    defaultMessage: 'For next purchase please create new order.',
    description:
      'For some countries there is a order limit which cant be exceeded. This message is part of the modal displayed to the customer',
  },

  orderLimitReachedHeader: {
    id: 'checkout.cartPage.orderLimitReached.header',
    defaultMessage: 'Your order has exceeded maximum allowed value.',
    description:
      'For some countries there is a order limit which cant be exceeded. This message is part of the modal displayed to the customer',
  },

  loyaltyToastMessage: {
    id: 'checkout.cartPage.loyaltyToastMessage',
    defaultMessage: 'We have returned your reward to MyRewards.',
    description: 'Message to show when loyalty reward is removed',
  },
  loyaltyTitle: {
    id: 'checkout.cartPage.loyaltyTitle',
    defaultMessage: 'Loyalty program',
  },
});
